module.exports = __webpack_public_path__ + "static/media/2020Mission.682f2eb7.pdf";